import {createFileRoute, redirect} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileNotCompleted")({
    beforeLoad: async ({context}) => {
        // await delay(1500);

        // #region de4f9400-0fdc-4f66-bc32-b53117938c13
        if (context.profileStatus.isProfileCompleted === true) {
            console.groupCollapsed("User has a completed profile, redirecting to home");
            console.log("profileStatus", context.profileStatus);
            console.groupEnd();

            // TODO: Get this from heimdallConfiguration or something
            const redirectTo = "/u";

            throw redirect({
                to: redirectTo,
                // TODO: Having to add this because.. idk, we are getting a blank screen without it in simulation.
                //       ref: 412ba837-f619-4f24-b94b-f6ea79db36db
                reloadDocument: true,
            });
        }
        // #endregion
    },
    loader: async () => {},
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
